import { render, staticRenderFns } from "./VAppSidebar.vue?vue&type=template&id=31c9f3c2&"
import script from "./VAppSidebar.vue?vue&type=script&lang=ts&"
export * from "./VAppSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./VAppSidebar.vue?vue&type=style&index=0&id=31c9f3c2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports